import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/dianying', label: '电影' },
    { to: '/category/dianshiju', label: '电视剧' },
    { to: '/category/zongyi', label: '综艺' },
    { to: '/category/dongman', label: '动漫' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="text-xl md:text-2xl font-heading font-bold text-primary-500 whitespace-nowrap">
            91天堂
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.to
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            注册会员
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-3 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors"
            >
              注册会员
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}